import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpPhysicalUnitSelector
     * @memberof app
     *
     * @restrict E
     * @scope {}
     *
     * @description
     * An amount field with dropdown to select physical unit part of the amount.
     *
     * @param {string[]} possiblePhysicalUnits
     *
     * @attr {expression} required Evaluates to `true` if the value is required, `false` otherwise.
     * @attr {expression} name The name of to give the input field.
     *
     * @author frbomke.btc
     */
    angular
        .module('app')
        .directive('pkpPhysicalUnitSelector', pkpPhysicalUnitSelector);

    function pkpPhysicalUnitSelector($translate) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                placeholder: '@',
                possiblePhysicalUnits: '=',
                preSelectedPhysicalUnit: '='
            },
            template:
                require('app/_directives/pkp-physical-unit-selector.directive.html'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            scope.updateAmount = updateAmount;
            scope.updateUnit = updateUnit;
            scope.required = attr.required;
            scope.minLength = attr.minLength;
            scope.minLengthError = attr.minLengthError;
            scope.maxLength = attr.maxLength;
            scope.maxLengthError = attr.maxLengthError;
            scope.name = attr.name;
            scope.selectedPhysicalUnit = null;

            ngModelCtrl.$formatters.push(convertToViewValue);
            ngModelCtrl.$parsers.push(convertToModelValue);

            if (!scope.selectedPhysicalUnit) {
                scope.selectedPhysicalUnit = scope.preSelectedPhysicalUnit;
            }

            scope.possiblePhysicalUnits = ['K_WH_H', 'K_WH_D'];

            /**
             * Set the `ngModel`'s `viewValue` by taking.
             *
             * @memberof app.pkpPhysicalUnitSelector
             */
            function updateAmount() {
                if (!angular.isUndefined(scope.amount)) {
                    if (scope.amount == null) {
                        ngModelCtrl.$setViewValue(null);
                    } else {
                        ngModelCtrl.$setViewValue(scope.amount.value);
                    }
                }
            }

            /**
             * @memberof app.pkpPhysicalUnitSelector
             * @param {string} newValue The new physical unit.
             * @returns {void}
             */
            function updateUnit(newValue) {
                scope.selectedPhysicalUnit = newValue;
                if (ngModelCtrl.$modelValue) {
                    ngModelCtrl.$modelValue.unit = $translate.instant(
                        'PhysicalUnit.' + scope.selectedPhysicalUnit
                    );
                }
            }

            /**
             * @memberof app.pkpPhysicalUnitSelector
             * @param {string} viewValue The view value that is displayed to the user.
             * @returns {Object}
             */
            function convertToModelValue(viewValue) {
                var modelValue = {
                    value: {
                        value: viewValue,
                        floatingPointNumber: true
                    },
                    unit: $translate.instant(
                        'PhysicalUnit.' + scope.selectedPhysicalUnit
                    )
                };
                return modelValue;
            }

            /**
             * @memberof app.pkpPhysicalUnitSelector
             * @param {Object} modelValue The model value.
             * @returns {string|undefined} The value the user will see in the input field.
             */
            function convertToViewValue(modelValue) {
                if (!modelValue || !modelValue.value) {
                    scope.amount = null;
                    return;
                }
                scope.amount = { value: modelValue.value.value };
                scope.selectedPhysicalUnit = convertToUnlocalizedString(
                    modelValue.unit
                );
                return modelValue.value;
            }

            function convertToUnlocalizedString(unit) {
                return unit == 'kWh/h' ? 'K_WH_H' : 'K_WH_D';
            }

            function convertToLocalizedString(unit) {
                return unit == 'K_WH_H' ? 'kWh/h' : 'kWh/d';
            }
        }
    }
})();
